<div *ngIf="layoutSettings" class="layoutDefinition">
  <wlm-dynamic-layout [settings]="layoutSettings"></wlm-dynamic-layout>
</div>
